import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormInputDirective } from '../../../../../../../common/directives/form-input.directive';
import { ProducerDto } from '../../../../../../../core/data/dtos/producer.dto';

@Component({
  selector: 'app-producer-selector',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormInputDirective,
  ],
  templateUrl: './producer-selector.component.html',
})
export class ProducerSelectorComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() producers: ProducerDto[] = [];
}
